import React from "react";

import "./Reviews.css";
import { Helmet } from "react-helmet-async";

const Reviews = () => {

    const reviews = [
        {
            name: "Harsh Mishra",
            role: "Software Developer",
            text: "The practical projects helped me understand how real development works."
        },
        {
            name: "Ankit Raj",
            role: "Full Stack Developer",
            text: "The mentor guidance and interview preparation improved my confidence."
        },
        {
            name: "Sai Charan",
            role: "Software Engineer",
            text: "The course helped me strengthen my fundamentals and prepare for interviews."
        }
    ];

    return (
        <>
            <Helmet>
    <title>PRT Academy Reviews | Student Feedback & Experiences</title>

    <meta
        name="description"
        content="Read PRT Academy reviews and student feedback about IT training, practical learning, live projects, internships, mentorship, and placement assistance in Hyderabad."
    />

    <meta
        name="keywords"
        content="PRT Academy Reviews, PRT Academy Hyderabad Reviews,
PRT Academy Student Reviews,
PRT Academy Student Feedback,
PRT Academy Training Reviews,
PRT Academy Reviews KPHB,
Student Feedback,
Placement Assistance,"
    />
</Helmet>

            <section className="reviews-page">

                <div className="page-badge">
                    Student Reviews
                </div>

                <h1>
                    What Our <span>Learners Say</span>
                </h1>

                <p className="page-intro">
                    Hear from learners who worked on practical projects and
                    prepared for software development careers.
                </p>

                <div className="reviews-grid">

                    {reviews.map((review, index) => (
                        <div className="review-card" key={index}>

                            <div className="stars">
                                ★★★★★
                            </div>

                            <p>
                                "{review.text}"
                            </p>

                            <h3>{review.name}</h3>
                            <span>{review.role}</span>

                        </div>
                    ))}

                </div>

            </section>

            
        </>
    );
};

export default Reviews;